// Relative Imports
import './ErrorPage.css';

const ErrorPage = (props) => {
    return (
        <div id="ErrorPage" className='page'>
            <div className='container'>
                <h1>Sorry, something went wrong.</h1>
                <p>Please try reloading the page. <a href="mailto:info@2minutewarning.com">Contact us</a> if you keep getting this error page.</p>
            </div>
        </div>
    );
};

export default ErrorPage;